import { Component, Inject, Input, OnInit } from '@angular/core';
import { GeneratedQrisResponse } from 'src/app/types/response/qrisly.response.type';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';

@Component({
  standalone: false,
  selector: 'app-modal-download-qris',
  templateUrl: './modal-download-qris.component.html',
  styleUrl: './modal-download-qris.component.scss'
})
export class ModalDownloadQrisComponent implements OnInit {
  data: GeneratedQrisResponse | null = null;
  qrLogoBase64: string = '';

  constructor(@Inject(NZ_MODAL_DATA) private modalData: any) {}

  ngOnInit(): void {
    if (this.modalData) {
      this.data = this.modalData.data;
      this.loadLogoAsBase64();
    }
  }

  private async loadLogoAsBase64() {
    const logoUrl = 'https://storage.googleapis.com/komerce/Qrisly/logo-only-qrisly.png';
    try {
      const response = await fetch(logoUrl);
      const blob = await response.blob();
      const reader = new FileReader();
      reader.onloadend = () => {
        this.qrLogoBase64 = reader.result as string;
      };
      reader.readAsDataURL(blob);
    } catch (error) {
      console.error('Error loading QR logo:', error);
      // Fallback: use the original URL if fetch fails (though it might still taint the canvas)
      this.qrLogoBase64 = logoUrl;
    }
  }

  async downloadQrCode() {
    const qrCodeContainer = document.getElementById('qrCodeDownload');
    const qrCanvas = qrCodeContainer?.querySelector('canvas');
    if (!qrCanvas) return;

    const dataURL = qrCanvas.toDataURL('image/png');
    const link = document.createElement('a');
    link.href = dataURL;
    link.download = `QRIS_${this.data?.history_id || 'code'}.png`;
    link.click();
  }
}
